import { createActionTypes } from '../../state/actions'

export const FETCH_PROJECTS = createActionTypes('FETCH_PROJECTS')
export const fetchProjects = (payload) => ({
  type: FETCH_PROJECTS.action,
  payload,
})
export const fetchProjectsSuccess = (payload) => ({
  type: FETCH_PROJECTS.success,
  payload,
})

export const RELOAD_PROJECT = createActionTypes('RELOAD_PROJECT')
export const reloadProject = (projectId, onComplete) => ({
  type: RELOAD_PROJECT.action,
  projectId,
  onComplete,
})
export const reloadProjectSuccess = (payload) => ({
  type: RELOAD_PROJECT.success,
  payload,
})

export const ADD_PROJECT = createActionTypes('ADD_PROJECT')
export const addProject = (payload, leadsData, onComplete) => ({
  type: ADD_PROJECT.action,
  payload,
  leadsData,
  onComplete,
})
export const addProjectSuccess = (payload) => ({
  type: ADD_PROJECT.success,
  payload,
})
export const addProjectFailed = (error) => ({
  type: ADD_PROJECT.failed,
  error,
})

export const DELETE_PROJECT = createActionTypes('DELETE_PROJECT')
export const deleteProject = (onComplete, projectId) => ({
  type: DELETE_PROJECT.action,
  onComplete,
  projectId,
})
export const deleteProjectSuccess = (payload) => ({
  type: DELETE_PROJECT.success,
  payload,
})
export const deleteProjectFailed = (error) => ({
  type: DELETE_PROJECT.failed,
  error,
})

export const CHANGE_CURRENT_PROJECT = createActionTypes(
  'CHANGE_CURRENT_PROJECT',
)
export const changeCurrentProject = (projectId) => ({
  type: CHANGE_CURRENT_PROJECT.action,
  projectId,
})

export const UPDATE_PROJECT = createActionTypes('UPDATE_PROJECT')
export const updateProject = (id, payload, onComplete) => ({
  type: UPDATE_PROJECT.action,
  id,
  payload,
  onComplete,
})
export const updateProjectSuccess = (payload) => ({
  type: UPDATE_PROJECT.success,
  payload,
})
export const updateProjectFailed = (error) => ({
  type: UPDATE_PROJECT.failed,
  error,
})

export const GET_DASHBOARD_COMPETITOR_ANALYSIS_REPORT = createActionTypes(
  'GET_DASHBOARD_COMPETITOR_ANALYSIS_REPORT',
)
export const getDashboardCompetitorAnalysisReport = (payload) => ({
  type: GET_DASHBOARD_COMPETITOR_ANALYSIS_REPORT.action,
  payload,
})
export const getDashboardCompetitorAnalysisReportPolling = (payload) => ({
  type: GET_DASHBOARD_COMPETITOR_ANALYSIS_REPORT.polling,
  payload,
})
export const getDashboardCompetitorAnalysisReportSuccess = (payload) => ({
  type: GET_DASHBOARD_COMPETITOR_ANALYSIS_REPORT.success,
  payload,
})
export const getDashboardCompetitorAnalysisReportFailed = (payload) => ({
  type: GET_DASHBOARD_COMPETITOR_ANALYSIS_REPORT.failed,
  payload,
})

export const CHANGE_COMPETITOR_TRACKING_LOCATION = createActionTypes(
  'UPDATE_COMPETITOR_TRACKING_LOCATION',
)
export const changeCompetitorTrackingLocation = (payload) => ({
  type: CHANGE_COMPETITOR_TRACKING_LOCATION.action,
  payload,
})

export const ADD_COMPETITOR_LOCATION = createActionTypes(
  'ADD_COMPETITOR_LOCATION',
)
export const addCompetitorLocation = (payload) => ({
  type: ADD_COMPETITOR_LOCATION.action,
  payload,
})

export const DELETE_COMPETITOR_LOCATION = createActionTypes(
  'DELETE_COMPETITOR_LOCATION',
)
export const deleteCompetitorLocation = (payload) => ({
  type: DELETE_COMPETITOR_LOCATION.action,
  payload,
})

export const ADD_COMPETITORS = createActionTypes('ADD_COMPETITORS')
export const addCompetitors = (payload) => ({
  type: ADD_COMPETITORS.action,
  payload,
})

export const DELETE_COMPETITORS = createActionTypes('DELETE_COMPETITORS')
export const deleteCompetitors = (payload, onComplete) => ({
  type: DELETE_COMPETITORS.action,
  payload,
  onComplete,
})

export const ADD_SEARCH_HISTORY = createActionTypes('ADD_SEARCH_HISTORY')
export const addSearchHistory = (searchType, searchParams) => ({
  type: ADD_SEARCH_HISTORY.action,
  searchType,
  searchParams,
})
export const addSearchHistorySuccess = (payload) => ({
  type: ADD_SEARCH_HISTORY.success,
  payload,
})
export const addSearchHistoryFailed = (payload) => ({
  type: ADD_SEARCH_HISTORY.failed,
  payload,
})
